'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of depression
 */ const Depression = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_20599)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M81.6758 46.2661C81.5406 31.3404 69.3378 19.1751 54.4121 19.0825C39.1811 18.99 26.8056 31.3104 26.8056 46.5189C26.8056 47.3748 26.8482 48.2132 26.9282 49.0465C26.9733 49.5321 26.8882 50.0226 26.683 50.463L22.4911 60.7664C22.3159 61.1943 22.3434 61.6823 22.5912 62.0727C22.8364 62.4631 23.2619 62.7034 23.7274 62.7184L27.2286 63.2765C27.8968 63.3841 28.3873 63.9322 28.4699 64.5979L29.7287 74.8011C29.9339 76.4704 31.3979 77.6941 33.0747 77.6016L37.3567 77.3688C39.7092 77.2412 41.6888 79.1156 41.6888 81.4731V84.7616C41.6888 84.9142 41.8114 85.0369 41.964 85.0369H71.465C71.6427 85.0369 71.7729 84.8692 71.7303 84.6965C69.5405 75.687 70.9095 70.0811 75.3041 64.1049C79.3308 59.2848 81.7383 53.0558 81.6758 46.2686V46.2661Z",
                    fill: theme.ds5.asset[assetColor]["500"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M52.3966 53.6366C52.3966 52.409 50.626 49.836 49.9029 48.8366C49.7539 48.63 49.4512 48.63 49.3023 48.8366C48.5816 49.8336 46.8086 52.4066 46.8086 53.6366C46.8086 55.179 48.0602 56.4306 49.6026 56.4306C51.1449 56.4306 52.3966 55.179 52.3966 53.6366Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M61.8028 58.9569C61.8028 57.7293 60.0323 55.1563 59.3091 54.1569C59.1602 53.9503 58.8575 53.9503 58.7085 54.1569C57.9878 55.1539 56.2148 57.7269 56.2148 58.9569C56.2148 60.4993 57.4665 61.7509 59.0088 61.7509C60.5512 61.7509 61.8028 60.4993 61.8028 58.9569Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M67.5835 32.3541C66.6129 29.0268 63.545 26.5956 59.9054 26.5956C57.7841 26.5956 55.8621 27.4268 54.4303 28.7721C52.936 27.273 50.8699 26.3457 48.5852 26.3457C44.6861 26.3457 41.4261 29.0532 40.5636 32.6881C37.5774 33.452 35.3672 36.1523 35.3672 39.3764C35.3672 43.1938 38.4615 46.2857 42.2765 46.2857H66.2069C70.0916 46.2857 73.2412 43.1361 73.2412 39.2514C73.2412 35.8376 70.8075 32.9932 67.5811 32.3541H67.5835Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_20599",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "59.2973",
                        height: "65.9518",
                        fill: "white",
                        transform: "translate(22.3789 19.082)"
                    })
                })
            })
        ]
    });
};

exports.Depression = Depression;
//# sourceMappingURL=Depression.cjs.map
